import dynamic from 'next/dynamic';

import {
  WIDGET_TYPES as TYPES,
  WIDGET_TEMPLATES as TEMPLATES,
} from './constants';
import { WidgetPlugin } from './types';

export const EviscoLivestreamPlugin: WidgetPlugin = {
  type: TYPES.EVISCO_LIVESTREAM,
  template: TEMPLATES.BASIC,
  component: dynamic(() =>
    import('@/components/atoms/LivePlayer/ThreePlayersSwitch').then(
      mod => mod.default,
    ),
  ),
  mapProps: () => {
    return {};
  },
};
